import { useMutation } from '@apollo/client'
import { CheckPassword as ChheckPasswordMutation } from '../../types'
import { CHECK_USER_PASSWORD } from './operations'

export const useCheckPassword = () => useMutation<ChheckPasswordMutation>(CHECK_USER_PASSWORD)
